import { configureStore } from "@reduxjs/toolkit";
import AuthReducer from "./features/authSlice";
import ListReducer from "./features/listSlice";

export default configureStore({
  reducer: {
    auth: AuthReducer,
     edos: ListReducer,
  },
});
